import { Typography } from '@evocolabs/orkaui'
import { ChevronRight24 } from '@evocolabs/icons'
import { Box } from '@mui/material'
const productName = 'Orka Two'
const productDescription = 'AI Hearing Aids'

const ProductTitle = function () {
  return (
    <Box
      onClick={() => {
        window.location.href = '/OrkaTwo'
      }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        }}
      >
        <Typography
          variant="h3"
          sx={{
            lineHeight: '44px !important',
            fontSize: '32px !important'
          }}
        >
          {productName}
        </Typography>
        <ChevronRight24 />
      </Box>
      <Typography variant="Body2">{productDescription}</Typography>
    </Box>
  )
}

export default ProductTitle
